/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of the lock currently applied to the agent.
 * @export
 */
export const AgentLockType = {
    Agency: 'AGENCY',
    Sabre: 'SABRE',
    Recall: 'RECALL'
} as const;
export type AgentLockType = typeof AgentLockType[keyof typeof AgentLockType];


export function AgentLockTypeFromJSON(json: any): AgentLockType {
    return AgentLockTypeFromJSONTyped(json, false);
}

export function AgentLockTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentLockType {
    return json as AgentLockType;
}

export function AgentLockTypeToJSON(value?: AgentLockType | null): any {
    return value as any;
}

